/**
 * 路由组件出口文件
 * yezi 2018年6月24日
 */
import Loadable from 'react-loadable';
import Loading from './widget/Loading';
import BasicTable from './tables/BasicTables';
import AdvancedTable from './tables/AdvancedTables';
import AsynchronousTable from './tables/AsynchronousTable';
import Echarts from './charts/Echarts';
import Recharts from './charts/Recharts';
import Icons from './ui/Icons';
import Buttons from './ui/Buttons';
import Spins from './ui/Spins';
import Modals from './ui/Modals';
import Notifications from './ui/Notifications';
import Tabs from './ui/Tabs';
import Banners from './ui/banners';
import Drags from './ui/Draggable';
import Dashboard from './dashboard/Dashboard';
import Gallery from './ui/Gallery';
import BasicAnimations from './animation/BasicAnimations';
import ExampleAnimations from './animation/ExampleAnimations';
import AuthBasic from './auth/Basic';
import RouterEnter from './auth/RouterEnter';
import Cssmodule from './cssmodule';
import MapUi from './ui/map';
import QueryParams from './extension/QueryParams';
import Visitor from './extension/Visitor';
import MultipleMenu from './extension/MultipleMenu';
import Sub1 from './smenu/Sub1';
import Sub2 from './smenu/Sub2';
import Env from './env';

import AccountView from '../main/account/AccountView';
import StoreView from '../main/store/StoreView';
import NoticeMessageView from '../main/notice/NoticeMessageView';
import CardDefinitionView from '../main/card/CardView';
import StudentView from '../main/student/StudentView';
import StudentCardView from '../main/student/StudentCardView';
import StudentPunchRecordView from '../main/student/StudentPunchRecordView';
import TeacherView from '../main/teacher/TeacherView';
import ScheduleView from '../main/schedule/ScheduleView';
import DataView from '../main/data/DataView';
import TeachClassStudentView from '../main/schedule/TeachClassStudentView';
import TeachClassCourseView from '../main/schedule/TeachClassCourseView';
import StoreClassroomList from '../main/store/StoreClassroomList';
import FinanceRecordView from '../main/financeRecord/FinanceRecordView';

const WysiwygBundle = Loadable({
    // 按需加载富文本配置
    loader: () => import('./ui/Wysiwyg'),
    loading: Loading,
});

export default {
    BasicTable,
    AdvancedTable,
    AsynchronousTable,
    Echarts,
    Recharts,
    Icons,
    Buttons,
    Spins,
    Modals,
    Notifications,
    Tabs,
    Banners,
    Drags,
    Dashboard,
    Gallery,
    BasicAnimations,
    ExampleAnimations,
    AuthBasic,
    RouterEnter,
    WysiwygBundle,
    Cssmodule,
    MapUi,
    QueryParams,
    Visitor,
    MultipleMenu,
    Sub1,
    Sub2,
    Env,

    AccountView,
    StoreView,
    NoticeMessageView,
    CardDefinitionView,
    StudentView,
    StudentCardView,
    StudentPunchRecordView,
    TeacherView,
    ScheduleView,
    TeachClassStudentView,
    TeachClassCourseView,
    DataView,
    StoreClassroomList,
    FinanceRecordView,
} as any;
